import { GET_AGENTS, GET_DEPARTAMENT } from './mutation-types'
import relatorioDisponibilidadeHttpService from '../_services/relatorioDisponibilidadeHttpService'

export default {
  listarDepartamento: async({ commit }) =>{
    try{
      const reponse = await relatorioDisponibilidadeHttpService.getDepartment()
      commit(GET_DEPARTAMENT, reponse.data)
    }catch(e){
      console.log(e)
    }
  },

  listarOperadores: async ({ commit }) => {
    try {
      const response = await relatorioDisponibilidadeHttpService.getAgents()
      commit(GET_AGENTS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
